// src/utils/dataLoader.js
// Додати функцію loadAllRawRecords або оновити існуючі

export const loadMeterData = async () => {
  try {
    // Демо дані
    return [
      { id: 1, date: '2024-01-15', value: 150, status: 'completed' },
      { id: 2, date: '2024-01-16', value: 145, status: 'completed' },
      { id: 3, date: '2024-01-17', value: 160, status: 'pending' }
    ];
  } catch (error) {
    console.error('Помилка завантаження метрологічних даних:', error);
    return [];
  }
};

export const loadShiftReports = async () => {
  try {
    // Демо дані
    return [
      { id: 1, date: '2024-01-15', production: 1000, defects: 5, status: 'completed' },
      { id: 2, date: '2024-01-16', production: 950, defects: 3, status: 'completed' },
      { id: 3, date: '2024-01-17', production: 1100, defects: 8, status: 'pending' }
    ];
  } catch (error) {
    console.error('Помилка завантаження звітів за зміну:', error);
    return [];
  }
};

export const loadTechnicalReports = async () => {
  try {
    // Демо дані
    return [
      { id: 1, date: '2024-01-15', equipment: 'Machine A', issues: 2, status: 'completed' },
      { id: 2, date: '2024-01-16', equipment: 'Machine B', issues: 1, status: 'completed' },
      { id: 3, date: '2024-01-17', equipment: 'Machine C', issues: 5, status: 'error' }
    ];
  } catch (error) {
    console.error('Помилка завантаження технічних звітів:', error);
    return [];
  }
};

// Нова функція для завантаження всіх даних
export const loadAllRawRecords = async () => {
  try {
    const [meterData, shiftReports, technicalReports] = await Promise.all([
      loadMeterData(),
      loadShiftReports(),
      loadTechnicalReports()
    ]);

    return {
      meterData,
      shiftReports,
      technicalReports,
      timestamp: new Date().toISOString()
    };
  } catch (error) {
    console.error('Помилка завантаження всіх даних:', error);
    return {
      meterData: [],
      shiftReports: [],
      technicalReports: [],
      timestamp: new Date().toISOString()
    };
  }
};


